import { Box, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Domains } from "../../data/Domains";
import views, { ViewProps } from "../../data/views.data";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { useVillageRules } from "../../hooks/useVillageRules";


const cardSx = {
  cursor: 'pointer',
  textDecoration:'none',
  width:'250px',
  '&:hover': {
    transition: 'transform .3s cubic-bezier(.2,.9,.3,1.3)',
    transform: 'scale(1.04)'
  }
};




export const Home: React.FC = ( ) => {

  const { domain, readonlyDomains } = useContext( VillageConsoleContext );

  const { getFunctionKey } = useVillageRules();

  useEffect(() => {

    const fetchData = async() => await getFunctionKey();
    fetchData();

  }, []);

  const cards = views.slice( 1 ).filter( ( view: ViewProps ) => view.isTopLevel && ( !readonlyDomains.includes( domain as Domains ) || view.canBeSeenInReadonlyMode )).map( ( view: ViewProps ) => 
    
    <Card sx={ cardSx } component={ NavLink } to={ view.path } key={ view.index }>
        <CardContent sx={{background:'#f77f00', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {
            // https://stackoverflow.com/questions/58878858/how-do-i-style-a-material-ui-icon-which-was-passed-as-prop
            React.cloneElement( view.icon as React.ReactElement, {
              style: { color:'white', fontSize:'50px' }
            })

          }
        </CardContent>
        <CardActions>
          <Typography sx={{ color:'black', display: 'block', padding:'20px', marginLeft: 'auto', marginRight:'auto' }}>
            { view.text }
          </Typography>
        </CardActions>
    </Card>
    
  );

  return (
    
    <>

      <Grid 
        container
        spacing={0}
        direction="row"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '80vh' }}
        gap={2}
      >
      
        {cards}

      </Grid>

    </>

  );

};